import { generalApiRequest } from "../../../api/apiIndex";

export default async function getDialysisTymes(session_id) {
  const url = "getElapsedMinutes";
  const res = await generalApiRequest(
    url,
    "GET",
    { session_id: session_id },
    1
  );
  return res;
}
